import React from 'react';
import { Link } from 'react-router-dom';
import VJLOGO from '../assets/logo/VJLOGO.png';
import './FooterInfo.css';

export default function FooterInfo() {
  return (
    <footer className="vj-modern-footer">
      <div className="container">
        <div className="row g-4">
          {/* Column 1: Brand & Mission */}
          <div className="col-lg-4 col-md-6">
            <div className="d-flex align-items-center gap-3 mb-3">
              <img
                src={VJLOGO}
                alt="Vidyajyoti College Library Logo"
                style={{
                  width: '46px',
                  height: '46px',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                  backgroundColor: '#ffffff',
                  padding: '2px'
                }}
              />
              <div>
                <div className="vj-footer-brand-title">FLYNN - MEAGHER</div>
                <div className="vj-footer-brand-sub">Library & Research Centre</div>
              </div>
            </div>

            <p className="vj-footer-desc">
              Vidyajyoti College of Theology (Institute of Religious Studies). Empowering theological scholarship, academic research, and intellectual formation through comprehensive physical and digital resources.
            </p>

            {/* Social Media Links */}
            <div className="d-flex align-items-center mt-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="vj-footer-social-btn"
                aria-label="Facebook"
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="vj-footer-social-btn"
                aria-label="Twitter"
              >
                <i className="bi bi-twitter"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="vj-footer-social-btn"
                aria-label="LinkedIn"
              >
                <i className="bi bi-linkedin"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="vj-footer-social-btn"
                aria-label="YouTube"
              >
                <i className="bi bi-youtube"></i>
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="col-lg-2 col-md-6 col-6">
            <h5 className="vj-footer-heading">Quick Links</h5>
            <ul className="vj-footer-links">
              <li>
                <Link to="/" className="vj-footer-link">
                  <i className="bi bi-chevron-right small text-info"></i> Home
                </Link>
              </li>
              <li>
                <Link to="/aboutus" className="vj-footer-link">
                  <i className="bi bi-chevron-right small text-info"></i> About Us
                </Link>
              </li>
              <li>
                <Link to="/search" className="vj-footer-link">
                  <i className="bi bi-chevron-right small text-info"></i> Search Catalogue
                </Link>
              </li>
              <li>
                <Link to="/managejournal" className="vj-footer-link">
                  <i className="bi bi-chevron-right small text-info"></i> Journals
                </Link>
              </li>
              <li>
                <Link to="/managebooks" className="vj-footer-link">
                  <i className="bi bi-chevron-right small text-info"></i> Books Library
                </Link>
              </li>
              <li>
                <Link to="/issuereturnbooks" className="vj-footer-link">
                  <i className="bi bi-chevron-right small text-info"></i> Issue / Return
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Library Services & Timings */}
          <div className="col-lg-3 col-md-6 col-6">
            <h5 className="vj-footer-heading">Library Services</h5>
            <ul className="vj-footer-links mb-3">
              <li>
                <span className="vj-footer-link" style={{ cursor: 'default' }}>
                  <i className="bi bi-book me-1 text-info"></i> Theological Theses & Books
                </span>
              </li>
              <li>
                <span className="vj-footer-link" style={{ cursor: 'default' }}>
                  <i className="bi bi-journal-album me-1 text-info"></i> Periodicals & Bound Volumes
                </span>
              </li>
              <li>
                <span className="vj-footer-link" style={{ cursor: 'default' }}>
                  <i className="bi bi-upc-scan me-1 text-info"></i> Barcode & Circulation
                </span>
              </li>
            </ul>

            <div className="vj-footer-timing-badge">
              <div className="vj-footer-timing-title">
                <i className="bi bi-clock-history me-1"></i> Library Hours
              </div>
              <div className="vj-footer-timing-hours">
                Mon – Fri: <strong>8:00 AM – 4:00 PM</strong><br />
                Saturday: <strong>8:00 AM – 12:00 Noon</strong><br />
                {/*Sunday & Holidays: <strong>Closed</strong>*/}
              </div>
            </div>
          </div>

          {/* Column 4: Contact & Location */}
          <div className="col-lg-3 col-md-6">
            <h5 className="vj-footer-heading">Get in Touch</h5>

            <a
              href="https://maps.google.com/?q=Vidyajyoti+College+of+Theology+Delhi"
              target="_blank"
              rel="noopener noreferrer"
              className="vj-footer-contact-item"
            >
              <i className="bi bi-geo-alt-fill vj-footer-contact-icon"></i>
              <span>
                4A, Raj Niwas Marg, Civil Lines, Delhi – 110054, India
              </span>
            </a>

            <a
              href="tel:+919205010207"
              className="vj-footer-contact-item"
            >
              <i className="bi bi-telephone-fill vj-footer-contact-icon"></i>
              <span>+91 92050 10207 / 98996 26793</span>
            </a>

            <a
              href="mailto:vidyajyotilibrary@gmail.com"
              className="vj-footer-contact-item"
            >
              <i className="bi bi-envelope-fill vj-footer-contact-icon"></i>
              <span>vidyajyotilibrary@gmail.com</span>
            </a>

            <a
              href="https://library.vidyajyoticollege.in"
              target="_blank"
              rel="noopener noreferrer"
              className="vj-footer-contact-item"
            >
              <i className="bi bi-globe2 vj-footer-contact-icon"></i>
              <span>library.vidyajyoticollege.in</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
